import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/articles';

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
            {t('articles.h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {articleCards.map((article) => (
            <Link
              key={article.slug}
              to={article.href}
              className="group block bg-white rounded-xl border border-warm-200 overflow-hidden hover:border-brand-200 transition-all duration-300 hover:shadow-sm"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={t(article.titleKey)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs text-warm-400">
                    {t('general.lastUpdated')}: {article.lastUpdated}
                  </span>
                  <span className="text-xs text-warm-400">
                    {article.readTime} {t('general.readTime')}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-warm-900 mb-2 group-hover:text-brand-600 transition-colors">
                  {t(article.titleKey)}
                </h3>
                <p className="text-xs md:text-sm text-warm-500 leading-relaxed mb-3">
                  {t(article.descKey)}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-brand-600 group-hover:text-brand-700 transition-colors">
                  {t('articles.readMore')}
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}